import { useState, useRef } from "react";
import { Link, useNavigate } from "react-router-dom";
import LandingIntro from "./LandingIntro";
import ErrorText from "../../components/Typography/ErrorText";
import InputText from "../../components/Input/InputText";
import React from "react";
import axios from 'axios';
import { TextField } from "@mui/material";
import GradientCircularProgress from "../../components/Loaders/GradientCircularProgress";

function Login() {

  const navigate = useNavigate();

  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const [siteUsers, setSiteUsers] = React.useState({});
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');

  var [retryCount, setRetryCount] = useState(0);
  var [disabled, setDisabled] = useState(false);

  const submitForm = async (e) => {
    e.preventDefault();
    setErrorMessage("");

    if (username.trim() === "")
      return setErrorMessage("Username is required!");
    if (password.trim() === "")
      return setErrorMessage("Password is required!");
    else {
      setLoading(true);

      try {
        const authResponse = await axios.get(`${process.env.REACT_APP_FMS_API_URL}AuthenticateUser?username=${username}&password=${password}`);

        if (authResponse.data.result) {

          const tokenResponse = await axios.get(`${process.env.REACT_APP_FMS_API_URL}GetToken`)
          if (tokenResponse.data.result) {
            localStorage.setItem("token", tokenResponse.data.result);

            const userResponse = await axios.get(`${process.env.REACT_APP_FMS_API_URL}GetUserByUsername?username=${username}`, { headers: { "Authorization": `Bearer ${localStorage.getItem("token")}` } })

            if (userResponse.data.result) {
              localStorage.setItem("firstName", userResponse.data.result.firstName);
              localStorage.setItem("lastName", userResponse.data.result.lastName);
              localStorage.setItem("username", userResponse.data.result.userName);
              localStorage.setItem("groupId", userResponse.data.result.groupId);

              if (userResponse.data.result.userName.includes("awg")) {
                localStorage.setItem("externalUser", "AWG");
              } else if (userResponse.data.result.userName.includes("zero")) {
                localStorage.setItem("externalUser", "ZERO");
              } else {
                localStorage.setItem("externalUser", "");
              }

              setLoading(false);
              window.location.href = "/app/welcome";
            }

          }

        } else {

          setRetryCount((retryCount += 1));
          console.log(retryCount);
          if (retryCount == 3) {
            setLoading(false);
            setDisabled(true);
            return setErrorMessage(
              "Number of retries exceeded. Please use the Forgot Password link to change your password"
            );
          }
          setLoading(false);
          return setErrorMessage("Invalid username/password");
        }

      }
      catch (error) {
        setErrorMessage('Error logging in');
        setLoading(false);
      }
    }
  };

  return (
    <div className="min-h-screen bg-base-200 flex items-center">
      <div className="card mx-auto w-full max-w-5xl  shadow-xl">
        <div className="grid  md:grid-cols-2 grid-cols-1  bg-base-100 rounded-xl">
          <div className="">
            <LandingIntro />
          </div>
          <div className="py-24 px-10 relative">
            <h2 className="text-2xl font-semibold mb-2 text-center">Login</h2>
            <form onSubmit={(e) => submitForm(e)}>
              <div className="mb-4">
                <TextField
                  fullWidth
                  label="Username"
                  placeholder="Username"
                  value={username}
                  InputLabelProps={{ shrink: true }}
                  onChange={(e) => setUsername(e.target.value)}
                />
                <br /><br />

                <TextField
                  fullWidth
                  label="Password"
                  placeholder="Password"
                  type="password"
                  value={password}
                  InputLabelProps={{ shrink: true }}
                  onChange={(e) => setPassword(e.target.value)}
                />

              </div>

              <div className="text-right text-primary">
                <Link to="/forgot-password">
                  <span
                    className="text-sm  inline-block  font-semibold hover:text-primary hover:underline hover:cursor-pointer transition duration-200"
                    style={{ color: "#30bfb6" }}
                  >
                    Forgot Password?
                  </span>
                </Link>
              </div>

              <ErrorText styleClass="mt-8">{errorMessage}</ErrorText>
              <button
                disabled={disabled || loading}
                type="submit"
                className={"btn mt-2 w-full"}
                style={{
                  backgroundColor: loading ? "#a0a0a0" : "lightgray",
                  cursor: loading ? "not-allowed" : "pointer"
                }}
              >
                {loading ? "Authenticating..." : "Login"}
              </button>
            </form>

            {loading && (
              <div
                style={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  width: '100%',
                  height: '100%',
                  backgroundColor: 'rgba(255, 255, 255, 0.85)',
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center',
                  alignItems: 'center',
                  zIndex: 1000,
                  borderTopRightRadius: '0.75rem',
                  borderBottomRightRadius: '0.75rem'
                }}
              >
                <GradientCircularProgress />
                <p className="text-white mt-4 text-lg font-medium">Logging in...</p>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default Login;
